import api from './api'

export const consignmentService = {
  getAll: (params?: { search?: string; status?: string; page?: number; limit?: number }) =>
    api.get('/consignments', { params }),

  getById: (id: number | string) =>
    api.get(`/consignments/${id}`),

  getAging: (days: number = 60) =>
    api.get('/consignments/aging', { params: { days } }),

  create: (data: any) =>
    api.post('/consignments', data),

  update: (id: number | string, data: any) =>
    api.put(`/consignments/${id}`, data),

  recordSale: (id: number | string, data: any) =>
    api.post(`/consignments/${id}/report-sale`, data),

  recall: (id: number | string, data?: { item_ids: number[]; reason?: string }) =>
    api.post(`/consignments/${id}/recall`, data),

  partialReturn: (id: number | string, data: { serials: number[]; reason?: string }) =>
    api.post(`/consignments/${id}/partial-return`, data),
}
